<!-- ── ESTIMATED WEEKLY RENT CALCULATOR ── -->
<app-ip-shell
  [activeStep]="2"
  [steps]="ewrSteps"
  calculatorName="Estimated Weekly Rent">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Estimated Weekly Rent</div>
      <h1 class="ip-form-head__title">Calculate your rental income</h1>
      <p class="ip-form-head__subtitle">
        Enter a property value and rental yield — or a known weekly rent — to get your full income breakdown.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- Property Value -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="propertyValue">Property value</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>UK avg: £300k</span>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="propertyValue"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 280,000"
            [(ngModel)]="PropertyValue"
            (input)="PropertyValue=validation.amountWithComma(PropertyValue); calcLive()"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Home Currency -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label">Home currency</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Returns shown in your currency</span>
        </div>
        <div class="s3-currency-wrap">
          <button
            type="button"
            class="s3-currency-btn"
            [class.open]="currencyDropdownOpen"
            [class.error-input]="homeCurrencyError"
            (click)="currencyDropdownOpen=!currencyDropdownOpen">
            <span class="s3-currency-val" [class.placeholder]="!homecurrencyText">
              {{ homecurrencyText ? selectedCurrencyName : 'Select currency' }}
            </span>
            <svg class="s3-currency-chevron" [class.rotated]="currencyDropdownOpen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
          </button>
          <div class="s3-dropdown" *ngIf="currencyDropdownOpen">
            <div class="s3-dropdown__search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
              <input type="text" class="s3-dropdown__input" placeholder="Search currency..." [(ngModel)]="currencySearch" autocomplete="off" (click)="$event.stopPropagation()">
            </div>
            <div class="s3-dropdown__list">
              <div
                *ngFor="let c of filteredCurrencies"
                class="s3-dropdown__item"
                [class.selected]="c.code===homecurrencyText"
                (click)="selectCurrency(c.code)">
                <span class="s3-dropdown__item-name">{{ stripCode(c.name) }}</span>
                <span class="s3-dropdown__item-code">{{ c.code }}</span>
              </div>
              <div class="s3-dropdown__empty" *ngIf="filteredCurrencies.length===0">No currencies found</div>
            </div>
          </div>
        </div>
        <p class="ip-field-error" *ngIf="homeCurrencyError">This field is required</p>
      </div>

      <!-- FX Rate (read-only) -->
      <div class="ip-field" *ngIf="homecurrencyText">
        <div class="ip-field__head">
          <label class="ip-field__label">FX rate (1 GBP)</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Live rate</span>
        </div>
        <div class="ip-input">
          <input type="text" class="ip-input__field" [value]="homecurrency || '—'" readonly>
          <span class="ip-input__suffix">{{ homecurrencyText }}</span>
        </div>
      </div>

      <!-- Input Mode Toggle -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label">I know the…</label>
        </div>
        <div class="ip-chip-row">
          <button class="ip-chip" [class.is-active]="inputMode==='yield'"  (click)="setMode('yield')"  type="button">Rental yield %</button>
          <button class="ip-chip" [class.is-active]="inputMode==='weekly'" (click)="setMode('weekly')" type="button">Weekly rent £</button>
        </div>
      </div>

      <!-- Yield mode -->
      <div class="ip-field" *ngIf="inputMode==='yield'">
        <div class="ip-field__head">
          <label class="ip-field__label" for="rentalYeild">Gross rental yield</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>UK typical: 3.5–5.5%</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="rentalYeild"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 5.5"
            [(ngModel)]="rentalYeild"
            (input)="rentalYeild=validation.appendPercent($event,rentalYeild); calcLive()"
            (keypress)="validation.DesimalOnly($event,rentalYeild)">
          <span class="ip-input__suffix">p.a.</span>
        </div>
      </div>

      <!-- Weekly rent mode -->
      <div class="ip-field" *ngIf="inputMode==='weekly'">
        <div class="ip-field__head">
          <label class="ip-field__label" for="weeklyRent">Known weekly rent</label>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="weeklyRent"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 500"
            [(ngModel)]="weeklyRent"
            (input)="weeklyRent=validation.amountWithComma(weeklyRent); calcLive()"
            (keypress)="validation.numberOnly($event)">
          <span class="ip-input__suffix">per week</span>
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/estimated-weekly-rent-calculator/step1']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--accent" type="button" (click)="next()">
        Calculate Returns
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL — live rental income preview ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ calcData?.City || 'United Kingdom' }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag" [class.is-uk]="foreignbuyer!=='1'">
          {{ foreignbuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">

        <!-- Property -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Property</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Property value</span>
            <span class="ip-rs-row__val">{{ PropertyValue ? ('£' + PropertyValue) : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Gross yield</span>
            <span class="ip-rs-row__val">{{ liveGrossYield ? ((liveGrossYield | number:'1.1-1') + '%') : '—' }}</span>
          </div>
        </div>

        <!-- Rental Income -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Rental Income</span>
            <span class="ip-rs-section__total">{{ liveAnnual ? ('£' + (liveAnnual | number:'1.0-0') + '/yr') : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Weekly</span>
            <span class="ip-rs-row__val">{{ liveWeekly ? ('£' + (liveWeekly | number:'1.0-0')) : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Monthly</span>
            <span class="ip-rs-row__val">{{ liveMonthly ? ('£' + (liveMonthly | number:'1.0-0')) : '—' }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Annual</span>
            <span class="ip-rs-row__val">{{ liveAnnual ? ('£' + (liveAnnual | number:'1.0-0')) : '—' }}</span>
          </div>
        </div>

      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">Annual rental income</div>
        <div class="ip-rail-summary__outlay-value">{{ liveAnnual ? ('£' + (liveAnnual | number:'1.0-0')) : '—' }}</div>
        <div class="ip-rail-summary__outlay-meta">{{ liveGrossYield ? ((liveGrossYield | number:'1.1-1') + '% gross yield') : 'Enter values to preview' }}</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
